module.exports = __webpack_public_path__ + "img/calculatorHeaderBanner.fb86748f.png";